/**
 * Indicates the method of preallocation.
 * tag: 591
 * @readonly
 * @enum {string} (char)
 */
export enum PreallocMethod {
  /** Pro rata */
  ProRata = '0',
  /** Do not pro-rata - discuss first */
  DoNotProRata = '1',
}
